import React, {useState} from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core';
import FormField from './FormField';
import { CONFIG_FIELD_BUTTON } from './formConfigs';
import {
  memoOfPartiesConfig,
  memoOfPartiesConfigRight
} from './formConfigs';
import { DeleteOutline } from '@material-ui/icons';

const MemoOfParties = ({handleFieldChangeClaimant, formValuesClaimant, createPartyIndividual, handleFieldChangeRespondent, formValuesRespondent, createRespondentIndividual, mainCaseUpdate, errorsClaimant, errorsRespondent, handleDeleteClaimant, handleDeleteRespondent}) => {

   const dynamicMemoConfig = {
    ...memoOfPartiesConfig,
    sections: memoOfPartiesConfig.sections.map(section => ({
      ...section,
      fields: section.fields.map(field => {
        if (field.type === CONFIG_FIELD_BUTTON) {
          return {
            ...field,
            label:
              (mainCaseUpdate?.claimant_parties?.length || 0) > 0
                ? "Add"
                : "Save"
          };
        }
        return field;
      })
    }))
  };

    const dynamicMemoConfigRight = {
    ...memoOfPartiesConfigRight,
    sections: memoOfPartiesConfigRight.sections.map(section => ({
      ...section,
      fields: section.fields.map(field => {
        if (field.type === CONFIG_FIELD_BUTTON) {
          return {
            ...field,
            label:
              (mainCaseUpdate?.respondent_parties?.length || 0) > 0
                ? "Add"
                : "Save"
          };
        }
        return field;
      })
    }))
  };
  return (
    <Box component="form" >
      <div style={{display: 'flex', flexDirection:'column', gap:'2rem'}}>
        <div style={{display:'flex'}}>
          {dynamicMemoConfig.sections.map((section, sectionIndex) => (
            <Paper key={sectionIndex} sx={{ p: 2, mb: 2 }} style={{padding: '3rem 5rem', width:'50%'}}>
              <Grid container spacing={2}>
                {section.fields.map((field, index) => (
                  <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'flex-start'}}>
                    <FormField 
                      field={field} 
                      value={formValuesClaimant[field.keyId] || ''} 
                      onChange={handleFieldChangeClaimant}  
                      onClick={field.type === CONFIG_FIELD_BUTTON ? createPartyIndividual : undefined}
                      error={errorsClaimant[field.keyId]}
                      disabled={field.keyId === 'type' &&  mainCaseUpdate?.claimant_parties?.length > 0}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>
          ))}
          {dynamicMemoConfigRight.sections.map((section, sectionIndex) => (
            <Paper key={sectionIndex} sx={{ p: 2, mb: 2 }} style={{padding: '3rem 5rem', width:'50%'}}>
              <Grid container spacing={2}>
                {section.fields.map((field, index) => (
                  <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'flex-start'}}>
                    <FormField 
                      field={field} 
                      value={formValuesRespondent[field.keyId] || ''} 
                      onChange={handleFieldChangeRespondent}  
                      onClick={field.type === CONFIG_FIELD_BUTTON ? createRespondentIndividual : undefined}
                      error={errorsRespondent[field.keyId]}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>
          ))}          
        </div>
        <div style={{display:'flex', padding:'1rem 0', background:'white'}}>
          <Paper sx={{ p: 2, mb: 2 }} style={{width: '50%', maxHeight: '200px', overflow: 'scroll', padding: '3rem 5rem'}}>
            <Grid container spacing={2}>
              {mainCaseUpdate?.claimant_parties?.map((party, index) => {
                return(
                  <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography style={{fontSize: '18px'}}>{party.type}&nbsp;{index+1}:</Typography>
                    <Grid item style={{display: 'flex', alignItems: 'center'}}>
                      <Typography style={{fontSize: '18px'}}>{party.full_name}</Typography>
                      <Button style={{marginLeft: '10px', fontSize: '18px', cursor: 'pointer'}} onClick={() =>handleDeleteClaimant(party.id)}><DeleteOutline/></Button>
                    </Grid>
                  </Grid>
                )
              })}
            </Grid>
          </Paper>
          <Paper sx={{ p: 2, mb: 2 }} style={{width: '50%',maxHeight: '200px', overflow: 'scroll', padding: '3rem 5rem'}}>
            <Grid container spacing={2}>
              {mainCaseUpdate?.respondent_parties?.map((party, index) => {
                return(
                  <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography style={{fontSize: '18px'}}>{party?.type}&nbsp;{index+1}:</Typography>
                    <Grid item style={{display: 'flex', alignItems: 'center'}}>
                      <Typography style={{fontSize: '18px'}}>{party?.full_name}</Typography>
                      <Button style={{marginLeft: '10px', fontSize: '18px', cursor: 'pointer'}} onClick={() =>handleDeleteRespondent(party.id)}><DeleteOutline/></Button>
                    </Grid>
                  </Grid>
                )
              })}
            </Grid>
          </Paper>
        </div>
      </div>
    </Box>
  );
};

export default MemoOfParties;
